import HomePageView from "./HomePageView";

export default HomePageView;
